/* ============================================================================
   Talkblox — ภาพประกอบ
   ----------------------------------------------------------------------------
   รูปหลักยังคงมีไฟล์ต้นฉบับเป็น fallback แต่เพิ่ม responsive WebP variants
   เพื่อให้ browser เลือกขนาดที่ใกล้กับพื้นที่แสดงจริงผ่าน srcset/sizes
   ลด transfer โดยไม่เปลี่ยน layout หรือดีไซน์
   ========================================================================== */

const heroPortrait = '/hero-portrait-480w.webp';
const heroPortrait480 = '/hero-portrait-480w.webp';
const heroPortrait720 = '/hero-portrait-720w.webp';
const heroPortrait820 = '/hero-portrait-820w.webp';

import personHospitality from './assets/person-hospitality.webp';
import personHospitality128 from './assets/person-hospitality-128w.webp';
import personHospitality192 from './assets/person-hospitality-192w.webp';
import personLogistics from './assets/person-logistics.webp';
import personLogistics128 from './assets/person-logistics-128w.webp';
import personLogistics192 from './assets/person-logistics-192w.webp';
import personHealthcare from './assets/person-healthcare.webp';
import personHealthcare128 from './assets/person-healthcare-128w.webp';
import personHealthcare192 from './assets/person-healthcare-192w.webp';

import industryHospitality from './assets/industry-hospitality.webp';
import industryHospitality320 from './assets/industry-hospitality-320w.webp';
import industryHospitality480 from './assets/industry-hospitality-480w.webp';
import industryHospitality640 from './assets/industry-hospitality-640w.webp';
import industryLogistics from './assets/industry-logistics.webp';
import industryLogistics320 from './assets/industry-logistics-320w.webp';
import industryLogistics480 from './assets/industry-logistics-480w.webp';
import industryLogistics640 from './assets/industry-logistics-640w.webp';
import industryHealthcare from './assets/industry-healthcare.webp';
import industryHealthcare320 from './assets/industry-healthcare-320w.webp';
import industryHealthcare480 from './assets/industry-healthcare-480w.webp';
import industryHealthcare640 from './assets/industry-healthcare-640w.webp';
import industryBusiness from './assets/industry-business.webp';
import industryBusiness320 from './assets/industry-business-320w.webp';
import industryBusiness480 from './assets/industry-business-480w.webp';
import industryBusiness640 from './assets/industry-business-640w.webp';

import featureLesson from './assets/feature-lesson.webp';
import featureLesson320 from './assets/feature-lesson-320w.webp';
import featureLesson640 from './assets/feature-lesson-640w.webp';
import featurePractice from './assets/feature-practice.webp';
import featurePractice320 from './assets/feature-practice-320w.webp';
import featurePractice640 from './assets/feature-practice-640w.webp';

import productDashboard from './assets/product-dashboard.webp';
import productDashboard768 from './assets/product-dashboard-768w.webp';
import productDashboard1280 from './assets/product-dashboard-1280w.webp';
import productDashboard1600 from './assets/product-dashboard-1600w.webp';
import productArchitecture from './assets/product-architecture.webp';
import productArchitecture768 from './assets/product-architecture-768w.webp';
import productArchitecture1280 from './assets/product-architecture-1280w.webp';
import productArchitecture1600 from './assets/product-architecture-1600w.webp';
import productArchitectureEn from './assets/product-architecture-en.webp';
import productArchitectureEn768 from './assets/product-architecture-en-768w.webp';
import productArchitectureEn1280 from './assets/product-architecture-en-1280w.webp';
import productArchitectureEn1600 from './assets/product-architecture-en-1600w.webp';

export const IMG = {
  heroPortrait,
  personHospitality,
  personLogistics,
  personHealthcare,
  industryHospitality,
  industryLogistics,
  industryHealthcare,
  industryBusiness,
  featureLesson,
  featurePractice,
  productDashboard,
  productArchitecture,
  productArchitectureEn,
};

export const IMG_SET = {
  heroPortrait: `${heroPortrait480} 480w, ${heroPortrait720} 720w, ${heroPortrait820} 820w`,
  people: [
    `${personHospitality128} 128w, ${personHospitality192} 192w, ${personHospitality} 240w`,
    `${personLogistics128} 128w, ${personLogistics192} 192w, ${personLogistics} 240w`,
    `${personHealthcare128} 128w, ${personHealthcare192} 192w, ${personHealthcare} 240w`,
  ],
  industry: {
    hospitality: `${industryHospitality320} 320w, ${industryHospitality480} 480w, ${industryHospitality640} 640w, ${industryHospitality} 700w`,
    logistics: `${industryLogistics320} 320w, ${industryLogistics480} 480w, ${industryLogistics640} 640w, ${industryLogistics} 700w`,
    healthcare: `${industryHealthcare320} 320w, ${industryHealthcare480} 480w, ${industryHealthcare640} 640w, ${industryHealthcare} 700w`,
    business: `${industryBusiness320} 320w, ${industryBusiness480} 480w, ${industryBusiness640} 640w, ${industryBusiness} 700w`,
  } as Record<string, string>,
  features: [
    `${featureLesson320} 320w, ${featureLesson640} 640w, ${featureLesson} 760w`,
    `${featurePractice320} 320w, ${featurePractice640} 640w, ${featurePractice} 760w`,
  ],
  productDashboard: `${productDashboard768} 768w, ${productDashboard1280} 1280w, ${productDashboard1600} 1600w, ${productDashboard} 1900w`,
  productArchitecture: `${productArchitecture768} 768w, ${productArchitecture1280} 1280w, ${productArchitecture1600} 1600w, ${productArchitecture} 1900w`,
  productArchitectureEn: `${productArchitectureEn768} 768w, ${productArchitectureEn1280} 1280w, ${productArchitectureEn1600} 1600w, ${productArchitectureEn} 1900w`,
};
